import { render, staticRenderFns } from "./HomeTopTour.vue?vue&type=template&id=222488d7"
import script from "./HomeTopTour.vue?vue&type=script&lang=js"
export * from "./HomeTopTour.vue?vue&type=script&lang=js"
import "./HomeTopTour.vue?vue&type=style&index=0&id=222488d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports